import { gql } from '@apollo/client'
import { pyramidForecastFragment } from './fragments/pyramidForecastFragment'

export const ReferencedPyramidsByCompanyId = gql`
  query ReferencedPyramidsByCompanyId($companyId: HashedId!, $country: Country!, $pyramidType: PyramidType!) {
    referencedPyramidsByCompanyIdAndCountry(companyId: $companyId, country: $country, pyramidType: $pyramidType) {
      id
      companyId
      referencePyramidType
      referencePyramidDetails {
        id
        displayOrder
        range
        limitType
        percentage
      }
    }
  }
`

export const PYRAMID_VALUES_AND_REFERENCE_PYRAMID = gql`
  query pyramidValuesAndReferencePyramids($companyId: HashedId!, $country: Country!, $pyramidType: PyramidType!) {
    referencePyramid: referencedPyramidsByCompanyIdAndCountry(companyId: $companyId, country: $country, pyramidType: $pyramidType) {
      id
      companyId
      referencePyramidType
      referencePyramidDetails {
        id
        displayOrder
        range
        limitType
        percentage
      }
    }
    pyramidValues: pyramidValues(companyId: $companyId, country: $country, pyramidType: $pyramidType) {
      name
      percentage
      count
      displayOrder
    }
  }
`

export const REFERENCE_PYRAMIDS = gql`
  query ageAndLevelReferencePyramids($companyId: HashedId!, $country: Country!) {
    ageReferencePyramid: referencedPyramidsByCompanyIdAndCountry(companyId: $companyId, country: $country, pyramidType: Age) {
      id
      companyId
      referencePyramidType
      referencePyramidDetails {
        id
        displayOrder
        range
        limitType
        percentage
      }
    }
    levelReferencePyramid: referencedPyramidsByCompanyIdAndCountry(companyId: $companyId, country: $country, pyramidType: Level) {
      id
      companyId
      referencePyramidType
      referencePyramidDetails {
        id
        displayOrder
        range
        limitType
        percentage
      }
    }
  }
`

export const REFERENCE_PYRAMID_TEMPLATES_BY_COUNTRY = gql`
  query ageAndLevelTemplatePyramids($country: Country!) {
    ageReferencePyramidTemplate: referencedPyramidsTemplateByCountryAndType(country: $country, referencePyramidType: Age) {
      id
      title
      country
      referencePyramidType
      referencePyramidTemplateDetails {
        id
        range
        limitType
        percentage
        displayOrder
      }
    }
    levelReferencePyramidTemplate: referencedPyramidsTemplateByCountryAndType(country: $country, referencePyramidType: Level) {
      id
      title
      country
      referencePyramidType
      referencePyramidTemplateDetails {
        id
        range
        limitType
        percentage
        displayOrder
      }
    }
  }
`

export const PAST_PYRAMID_VALUES = gql`
  query pyramidPastValues($companyId: HashedId!, $country: Country!, $pyramidType: PyramidType!, $year: Float!, $month: Float!) {
    pyramidPastValues(companyId: $companyId, country: $country, pyramidType: $pyramidType, year: $year, month: $month) {
      name
      count
      percentage
      displayOrder
    }
  }
`

export const PAST_PYRAMID_SELECTOR = gql`
  query pyramidPastValueSelector($companyId: HashedId!, $country: Country!, $pyramidType: PyramidType!) {
    pyramidPastValueSelector(companyId: $companyId, country: $country, pyramidType: $pyramidType) {
      options {
        value
        label
        children {
          value
          label
        }
      }
    }
  }
`

export const PYRAMID_FORECAST_WITH_FILTERS = gql`
  query pyramidForecastWithFilters($companyId: HashedId!, $country: Country!) {
    pyramidForecastWithFilters(companyId: $companyId, country: $country) {
      activeEmployees {
        ...PyramidForecastFragment
      }
      newHirings {
        ...PyramidForecastFragment
      }
      filters {
        businessUnits {
          id
          name
          isExpired
        }
        employees {
          id
          firstName
          lastName
        }
      }
      careerPath {
        careerPathType
        country
        level
        min
        max
      }
    }
    employeeLevels: getCountryEmployeeLevels(country: $country)
    isEmployeeLevelValidationEnabled(country: $country)
  }

  ${pyramidForecastFragment}
`

export const PYRAMID_FORECAST_SELECTOR = gql`
  query pyramidForecastValueSelector($companyId: HashedId!, $country: Country!) {
    pyramidForecastValueSelector(companyId: $companyId, country: $country) {
      options {
        value
        label
        children {
          value
          label
        }
      }
    }
  }
`

export const PYRAMID_FORECAST_VALUES = gql`
  query pyramidForecastValues($companyId: HashedId!, $country: Country!, $year: Float!, $month: Float!) {
    pyramidForecastValues(companyId: $companyId, country: $country, year: $year, month: $month) {
      values {
        name
        count
        percentage
      }
      decrease {
        name
        count
      }
      ageValues {
        name
        count
        percentage
      }
    }
  }
`
